import { render, staticRenderFns } from "./SlPoper.vue?vue&type=template&id=79045573&scoped=true&"
import script from "./SlPoper.vue?vue&type=script&lang=js&"
export * from "./SlPoper.vue?vue&type=script&lang=js&"
import style0 from "./SlPoper.vue?vue&type=style&index=0&id=79045573&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79045573",
  null
  
)

export default component.exports